import { useTranslation } from '@gimlite/common';
import { WizardItemType, Zone } from '@gimlite/ui-v1';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ContractMotoristLine } from '../../../../composition/line/contract-motorist.line';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ConfirmationForm } from '../../../../form/confirmation/confirmation.form';
import { AddSeveralMotoristsToAnExistingPoolContractWizardContext } from '../../addSeveralMotoristsToAnExistingPoolContract.wizard';

export const ConfirmationStep = ({
  context: { contractBase: contract, contractsDetails, contractMode },
  validate,
  submit,
}: WizardItemType.Config.Component<AddSeveralMotoristsToAnExistingPoolContractWizardContext>) => {
  const { t, lang } = useTranslation();

  const [allFeatures, setAllFeatures] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const features: JSX.Element[] = [];

    if (contractMode === 'create') {
      contractsDetails.created.forEach(({ email, firstName, lastName }) => {
        features.push(
          <ContractMotoristLine
            config={{
              action: false,
            }}
            data={{
              firstName,
              lastName,
              status: contract.state ? 'ACTIVE' : 'SUSPENDED',
              contractId: t('willBeGenerated'),
            }}
          />,
        );
      });
    } else {
      contractsDetails.checked.forEach(({ name1, name2 }) => {
        features.push(
          <ContractMotoristLine
            config={{
              action: false,
            }}
            data={{
              firstName: name1 || null,
              lastName: name2 || null,
              status: contract.state ? 'ACTIVE' : 'SUSPENDED',
              contractId: t('willBeGenerated'),
            }}
          />,
        );
      });
    }

    setAllFeatures(features);
  }, [lang]);

  return (
    <Zone
      config={{
        gap: {
          y: 1,
          x: 1,
        },
        zones: [['info', 'list']],
        rows: ['1fr'],
        columns: ['min-content', '1fr'],
      }}
    >
      <Zone.Area config={{ area: 'info' }}>
        <ContractWizardInfos
          data={{
            APBMode: contract.APBMode,
            APBNext: contract.APBMode !== 'NONE' ? contract.APBNext : null,
            state: contract.state,
            startDate: contract.startDate,
            endDate: contract.endDate,
            description: contract.description,
            reference: contract.reference,
            articleCode: contract.articleCode,
          }}
        />
      </Zone.Area>

      <Zone.Area config={{ area: 'list' }}>
        <ConfirmationForm
          data={{
            list: allFeatures.map((node) => {
              return {
                _id: uuidv4(),
                items: {
                  component: node,
                },
              };
            }),
          }}
        />
      </Zone.Area>
    </Zone>
  );
};
